export type SupplierStatus = 'ACTIVE' | 'INACTIVE'

export type GoodsCategory = {
  id: string
  code: string
  name: string
  isActive: boolean
}

export type PaymentTerm = {
  id: string
  code: string
  name: string
  days: number | null
  isActive: boolean
}

/** Production-shaped supplier mock (UI only). */
export type Supplier = {
  id: string
  code: string
  name: string
  category_ids: string[]
  address?: string
  contact_person?: string
  phone?: string
  email?: string
  tax_code?: string
  default_vat_rate: number
  payment_term_id: string
  lead_time_days: number
  status: SupplierStatus
  note?: string
  created_at: string
  updated_at: string
}

export type SupplierInput = {
  code: string
  name: string
  category_ids: string[]
  /** 'PO': NCC tự tạo khi lập PO, chưa cần nhóm hàng. */
  created_from?: 'PO'
  address?: string
  contact_person?: string
  phone?: string
  email?: string
  tax_code?: string
  default_vat_rate: number
  payment_term_id: string
  lead_time_days: number
  status: SupplierStatus
  note?: string
}

export const SUPPLIER_STATUS_LABEL: Record<SupplierStatus, string> = {
  ACTIVE: 'Đang hoạt động',
  INACTIVE: 'Ngừng hoạt động',
}
